import { StatusChip } from '@/components/legacy-ui/StatusChip';
import { cn } from '@/utils/classname';

export const ScanStatusTag = ({
  isFrozen,
  className,
}: {
  isFrozen: boolean;
  className?: string;
}) => {
  if (isFrozen) {
    return (
      <StatusChip label="Paused" variant="critical" className={cn(className)} />
    );
  }

  return <StatusChip label="Active" variant="info" className={cn(className)} />;
};
